/** Opzioni dei selettori Pulsar: due enum diversi dell'API, da non confondere. */

export interface ChipOption {
  value: string;
  label: string;
}

/**
 * Categorie dei historic e della creazione delle search (TopicsCategoryEnum /
 * HistoricCategoryEnum): sottoinsieme verificato su Pulsar_Trac_API_Schema.docx.
 */
export const PULSAR_HISTORIC_CATEGORIES: readonly ChipOption[] = [
  { value: 'ONLINE_NEWS', label: 'Notizie online' },
  { value: 'X',           label: 'X (Twitter)' },
  { value: 'REDDIT',      label: 'Reddit' },
  { value: 'FORUMS',      label: 'Forum' },
  { value: 'BLOGS',       label: 'Blog' },
  { value: 'TV',          label: 'TV' },
  { value: 'RADIO',       label: 'Radio' },
  { value: 'PODCAST',     label: 'Podcast' },
  { value: 'REVIEWS',     label: 'Recensioni' },
];

/** Fonti del filtro FilterInput.sources (SourcesEnum), per il perimetro dell'analisi. */
export const PULSAR_SOURCES: readonly ChipOption[] = [
  { value: 'ONLINE_NEWS',      label: 'Notizie online' },
  { value: 'PRINT_NEWS',       label: 'Stampa' },
  { value: 'TV',               label: 'TV' },
  { value: 'RADIO',            label: 'Radio' },
  { value: 'PODCAST',          label: 'Podcast' },
  { value: 'BLOG',             label: 'Blog' },
  { value: 'FORUM',            label: 'Forum' },
  { value: 'REDDIT',           label: 'Reddit' },
  { value: 'X',                label: 'X (Twitter)' },
  { value: 'FACEBOOK_PUBLIC',  label: 'Facebook' },
  { value: 'INSTAGRAM_PUBLIC', label: 'Instagram' },
  { value: 'YOUTUBE',          label: 'YouTube' },
  { value: 'TIKTOK',           label: 'TikTok' },
  { value: 'THREADS',          label: 'Threads' },
  { value: 'LINKEDIN',         label: 'LinkedIn' },
];
